<template>
  <SearchableModel
    v-bind="$attrs"
    model-name="Tour"
    sort="start_at"
    without-limit-change
    ref="searchableRef"
  >
    <template #default="{ models }">
      <div class="tw:rounded-lg tw:border tw:border-zinc-200 tw:overflow-hidden tw:bg-white tw:divide-y tw:divide-zinc-200">
        <div
          v-for="tour in models"
          :key="tour.id"
          class="tw:flex tw:items-center tw:gap-2 tw:md:gap-0"
        >
          <div class="tw:px-4 tw:py-3 tw:md:px-5 tw:flex-1 tw:min-w-0">
            <TourInformation :tour="tour" :open-in-new-window="opt.openTourInNewWindow" />
          </div>
          <slot name="columns" :tour="tour" />
        </div>
      </div>
    </template>
  </SearchableModel>
</template>

<script setup>
import { reactive, useTemplateRef, onMounted } from 'vue'
import SearchableModel from '@/components/searchable-model/SearchableModel.vue'
import TourInformation from '@/components/Tour/TourInformation.vue'
import { on as onEvent } from '@/eventBus.js'

defineOptions({ inheritAttrs: false })

const props = defineProps({
  options: {
    type: Object,
    default: () => ({}),
  },
})

const opt = reactive({
  openTourInNewWindow: false,
  ...props.options,
})

const searchableRef = useTemplateRef('searchableRef')

onMounted(() => {
  onEvent('refresh-tours-list', () => {
    searchableRef.value?.refresh()
  })
})

defineExpose({
  refresh: () => searchableRef.value?.refresh(),
})
</script>
